import { render, staticRenderFns } from "./Turnstile_ready.vue?vue&type=template&id=0713f73e&scoped=true"
import script from "./Turnstile_ready.vue?vue&type=script&lang=js"
export * from "./Turnstile_ready.vue?vue&type=script&lang=js"
import style0 from "./Turnstile_ready.vue?vue&type=style&index=0&id=0713f73e&prod&lng=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713f73e",
  null
  
)

export default component.exports